<template>
  <svg
    id="Capa_1"
    enable-background="new 0 0 512 512"
    height="15px"
    viewBox="0 0 512 512"
    width="15px"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <linearGradient
      id="todays1"
      gradientUnits="userSpaceOnUse"
      x1="256"
      x2="256"
      y1="512"
      y2="0"
    >
      <stop offset="0" stop-color="#fd5900" />
      <stop offset="1" stop-color="#ffde00" />
    </linearGradient>
    <linearGradient
      id="todays2"
      gradientUnits="userSpaceOnUse"
      x1="256"
      x2="256"
      y1="392.353"
      y2="91"
    >
      <stop offset="0" stop-color="#ffe59a" />
      <stop offset="1" stop-color="#ffffd5" />
    </linearGradient>
    <g id="Star">
      <g>
        <g>
          <circle cx="256" cy="256" fill="url(#todays1)" r="256" />
        </g>
      </g>
      <g>
        <g>
          <path
            d="m412.924 205.012c-1.765-5.43-6.458-9.388-12.108-10.209l-90.771-13.19-40.594-82.252c-2.527-5.12-7.742-8.361-13.451-8.361s-10.924 3.241-13.451 8.362l-40.594 82.252-90.771 13.19c-5.65.821-10.345 4.779-12.109 10.209s-.292 11.391 3.796 15.376l65.683 64.024-15.506 90.404c-.965 5.627 1.348 11.315 5.967 14.671 4.62 3.356 10.743 3.799 15.797 1.142l81.188-42.683 81.188 42.683c5.092 2.676 11.212 2.189 15.797-1.142 4.619-3.356 6.933-9.043 5.968-14.671l-15.506-90.404 65.682-64.024c4.088-3.986 5.559-9.947 3.795-15.377z"
            fill="url(#todays2)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "todaysIcon",
};
</script>
